import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ctrl",
  "use": "ctrl-usage",
  "viewBox": "0 0 21 17.5",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 17.5\" id=\"ctrl\"><defs><style>#ctrl .cls-1{isolation:isolate}</style></defs><title>资源 8</title><g id=\"ctrl_图层_2\" data-name=\"图层 2\"><g id=\"ctrl_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M19.52 0h-18A1.56 1.56 0 0 0 0 1.64v14.22a1.56 1.56 0 0 0 1.48 1.64h18A1.56 1.56 0 0 0 21 15.86V1.64A1.57 1.57 0 0 0 19.52 0zm0 15.86h-18V1.64h18z\" /><path d=\"M15.45 5.33h-4.59a2.39 2.39 0 0 0-4.56 0h-.75a.74.74 0 1 0 0 1.47h.75a2.39 2.39 0 0 0 4.56 0h4.59a.74.74 0 1 0 0-1.47zM9.38 6.8a1.08 1.08 0 1 1 .29-.73 1.07 1.07 0 0 1-.29.73zm-3.83 3.9h4.59a2.39 2.39 0 0 1 4.56 0h.75a.74.74 0 1 1 0 1.47h-.75a2.39 2.39 0 0 1-4.56 0H5.55a.74.74 0 1 1 0-1.47zm6.07 1.47a1.08 1.08 0 1 0-.29-.74 1.07 1.07 0 0 0 .29.74z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/ctrl.svg
// module id = NCJS
// module chunks = 6